import { Card as CardAntd, Steps as StepsAntd } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .height-85 {
    height: '85vh';
    min-height: '85vh';
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  h3.ant-typography {
    font-size: 20px;
    color: #676A6C;
    margin-top: 40px;
  }
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 12px 24px;
  }
`;

export const Steps = styled(StepsAntd)`
  .ant-steps-item-title,
  .ant-steps-icon {
    font-weight: bold;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    border-bottom: dashed #1890ff;
    border-radius: unset;
    background-color: unset;
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: #fff;
    border: 1px dashed #4190f7;
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-icon
    .ant-steps-icon,
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    background-color: #fff;
    color: #4190f7 !important;
  }

  .ant-steps .ant-steps-item-finish .ant-steps-icon,
  .ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: #676a6c !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background: #4190f7;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #fff;
  }
`;
